<template>
<bvue-ui-view class="p-0 flex flex-col">
  <img ref="img" :src="modalData.base64Image" />
  <div class="flex justify-end">
    <button class="btn mr-2" @click="$bvueUi.modal.close()">Cerrar</button>
    <button class="btn btn-primary" @click="applyChanges()">Aplicar</button>
  </div>
</bvue-ui-view>
</template>

<script>
import Cropper from 'cropperjs'

const baseOptions = {
  viewMode: 1
}

export default {
  props: {
    modalData: Object
  },
  mounted () {
    this.$cropper = new Cropper(this.$refs.img, {
      ...baseOptions,
      aspectRatio: this.modalData.width / this.modalData.height,
      ...(this.modalData.options || {})
    })
  },
  methods: {
    applyChanges () {
      this.$bvueUi.modal.close(this.$cropper.getCroppedCanvas().toDataURL())
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ImageUploaderCropper.vue